module.exports = __webpack_public_path__ + "static/media/google_analytics_icon.cac12b8d.svg";